import { render } from "./SeatPermissionAdd.vue?vue&type=template&id=3d103e96&scoped=true"
import script from "./SeatPermissionAdd.vue?vue&type=script&lang=js"
export * from "./SeatPermissionAdd.vue?vue&type=script&lang=js"

import "./SeatPermissionAdd.vue?vue&type=style&index=0&id=3d103e96&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d103e96"]])

export default __exports__